import React, { createContext, memo, useContext, useMemo } from 'react';

import { UserWidgetStore } from '../store';

const Context = createContext<UserWidgetStore | null>(null);

export const useProfileWidgetStore = () => useContext(Context)!;

export const StoreProvider = memo<{ children: React.ReactNode }>(({ children }) => {
  const store = useMemo(() => new UserWidgetStore(), []);

  return <Context.Provider value={store}>{children}</Context.Provider>;
});
